import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalStyle as PhishToolGlobalStyle, Router } from '@phishtool/ui';
import Page from '~components/page';
import routes from './router/routes';
import Header from '~components/header';
import Footer from '~components/footer';
import CookieBanner from '~components/cookie-banner';
import NotFound from '~pages/not-found';
import ErrorComponent from '~components/error';
import GlobalStyle from '~styles/global-style';
import { useAnalytics } from '@phishtool/analytics';
const App = () => {
    useAnalytics();
    return (_jsxs(_Fragment, { children: [_jsx(PhishToolGlobalStyle, {}), _jsx(GlobalStyle, {}), _jsx(Header, {}), _jsx(Page, { children: _jsx(Router, { routes: routes, titlePrefix: "PhishTool", NotFoundComponent: NotFound, ErrorComponent: ErrorComponent, workspace: null }) }), _jsx(Footer, {}), _jsx(CookieBanner, {}), _jsx("div", { id: "portal" })] }));
};
export default App;
